<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JCgVZZ/tc-custom/9780230101005.jpg?1733043476054" alt="This image is the cover for the book New American Economy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">New American Economy
      </h1>
      <p class="bookDescription body article font2">
        <p>As a domestic policy advisor to Ronald Reagan, Bruce Bartlett was one of the originators of Reaganomics, the supply-side economic theory that conservatives have clung to for decades. In <i>The New American Economy</i>, Bartlett goes back to the economic roots that made <i>Impostor</i> a bestseller and abandons the conservative dogma in favor of a policy strongly based on what's worked in the past. Marshalling compelling history and economics, he explains how economic theories that may be perfectly valid at one moment in time under one set of circumstances tend to lose validity over time because they are misapplied under different circumstances. Bartlett makes a compelling, historically-based case for large tax increases, once anathema to him and his economic allies. In <i>The New American Economy</i>, Bartlett seeks to clarify a compelling and way forward for the American economy.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bruce Bartlett
      </h2>
      
      <p class="authorDescription body article"><P><B>Bruce Bartlett</B> is an economic historian who has spent the last 30 years working in politics and public policy. He has served in numerous governmental positions, including as a domestic policy adviser to President Ronald Reagan and a treasury official under President George H.W. Bush. He is a weekly columnist for Forbes.com. and has written for <I>The New York Times, Wall Street Journal,  National Review, Commentary</I>, and <I>Fortune</I>. He is also a frequent guest on The NewsHour with Jim Lehrer, Lou Dobbs' Moneyline, NBC Nightly News, Nightline, Crossfire, Wall Street Week, CNN, CNBC, and Fox News Channel, among others.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?56116685